import { agencyUrls } from './agencyUrls';

/**
 * Returns the Agency URL set to use during the agencyskin rebrand.
 *
 * Pass the value of the `agency-rebrand` LaunchDarkly flag
 * (`useFlag('agency-rebrand')` on the client, `getFlag` on the server). When it
 * is on, `site` resolves to agencyskin.com; otherwise it stays on withagency.
 *
 * Only `site` moves. `base`, `api` and `legacy` all derive from
 * NEXT_PUBLIC_AGENCY_APP_URL, which is the origin for every authenticated /api
 * call — repointing it would break session, CSRF and checkout until the backend
 * serves app.agencyskin.com under the same session. `hydrogen` is unaffected by
 * the rebrand. Widen this only alongside that backend work.
 */
export const getActiveAgencyUrls = (isRebrandLive: boolean) => {
  const { rebrand, ...legacyUrls } = agencyUrls;

  return {
    ...legacyUrls,
    site: isRebrandLive ? rebrand.site : legacyUrls.site,
  };
};
